// extracted by mini-css-extract-plugin
module.exports = {"stateBox":"StateBox_stateBox__2wXi6","textStepBox":"StateBox_textStepBox__Gc7TG","icon":"StateBox_icon__37PG4"};